export default __webpack_public_path__ + "static/media/vol4Issue2.38eb4744.png";